import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchVoiceLinesSplit, voiceLinesSplitQueryKey } from '../../../features/scenarios/api';
import { NarrationSplitEditorModal } from './NarrationSplitEditorModal';
import styles from './ScenarioGenerator.module.css';

/**
 * ナレーションの分割位置を調整するモーダルを開くボタン (ハサミ・「すべてのナレーションを再生」の右・アイコンのみ)。
 * まとめて読んだ分割前音声 (voice-lines/split の chunks) が無いとき (生成前・1 行ずつ読んだだけ・30 日で消えた等) は何も描画しない。
 */
export function NarrationSplitButton({ scenarioId, disabled }: { scenarioId: string; disabled?: boolean }) {
  const { data } = useQuery({
    queryKey: voiceLinesSplitQueryKey(scenarioId),
    queryFn: () => fetchVoiceLinesSplit(scenarioId),
    staleTime: 60_000,
  });
  const [open, setOpen] = useState(false);
  if (!data?.chunks?.length) return null;
  return (
    <>
      <button
        type="button"
        className={`${styles.voicePreviewBtn} ${open ? styles.voicePreviewBtnActive : ''}`}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        disabled={disabled}
        data-tooltip="分割位置を調整"
        aria-label="ナレーションの分割位置を調整"
      >
        {/* ハサミ */}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round">
          <circle cx="4" cy="4.5" r="2" />
          <circle cx="4" cy="11.5" r="2" />
          <path d="M5.7 5.6 13.5 12M5.7 10.4 13.5 4" />
        </svg>
      </button>
      {open && <NarrationSplitEditorModal scenarioId={scenarioId} onClose={() => setOpen(false)} />}
    </>
  );
}
